import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { PaymentCardDto } from '../dtos';
import { CanPayResults } from '../enums/can-pay-response.enum';

export class PaymentCardsState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public paymentCards: PaymentCardDto[];
  public canPay: CanPayResults;
  public selectedPaymentCard: PaymentCardDto;
  public deletedPaymentSuccess: Object;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.paymentCards = null;
    this.canPay = null;
    this.selectedPaymentCard = null;
    this.deletedPaymentSuccess = null
  }
}
